import {
  SET_VIEWPORT_MOBILE
} from 'app/actions/types';

export const setViewportMobile = isMobile => dispatch => {
  dispatch({
    type: SET_VIEWPORT_MOBILE,
    payload: isMobile
  });
}
